import type { OrderDeliveryMethod, OrderDto } from '@/shared/api/order';

const ORDER_DELIVERY_METHODS_MAPPING: Record<OrderDeliveryMethod, string> = {
    COURIER: 'Доставка курьером',
    PICKUP_POINT: 'Доставка в пункт выдачи заказов',
    SELF_PICK_UP: 'Самовывоз',
} as const;

export const getOrderDeliveryMethod = (order: OrderDto): string | null =>
    ORDER_DELIVERY_METHODS_MAPPING[order.delivery.method] ?? null;
